import { getStakingPlanApi, addStakingPlanApi, updateStakingPlanApi } from "../components/constant/Api";
import { myApi } from "./api";

export const stakingApi = myApi.injectEndpoints({
    endpoints: (builder) => ({
        getStakingPlan: builder.query({
            query: () => ({
                url: getStakingPlanApi,
                method: "GET",
            }),
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: ["stakingPlan"],
        }),
        addStakingPlan: builder.mutation({
            query: (post) => ({
                url: addStakingPlanApi,
                method: "POST",
                body: post,
            }),
            invalidatesTags: ["stakingPlan"],
        }),
        updateStakingPlan: builder.mutation({
            query: (post) => ({
                url: updateStakingPlanApi,
                method: "POST",
                body: post,
            }),
            invalidatesTags: ["stakingPlan"],
        }),
    }),
});

export const {
    useGetStakingPlanQuery,
    useAddStakingPlanMutation,
    useUpdateStakingPlanMutation,
} = stakingApi;
